// Chat

<template>
<section class="lms4900-container">
  <!-- <component :is="'script'" src="socket.io/socket.io.js"/> -->

  <div class="lms4900 white border-main shadow-dark">

    <header class="chat-header charcoal curved-top-1">
      <div class="d-flex justify-between align-items-center w-100">
        <p class="chat-app-name mb-0"><i class="fa fa-comments-o fa-lg text-goldenrod mr-2"></i>LAMS Chat</p>
        <button @click="onExitRoom" class="exit-room warning darken-2" v-show="roomId">Leave Room</button>
      </div>
      <sym-combo class="room-select" v-model="roomId" display-field="roomName" :datasource="rooms" @changed="onRoomIdChanged" v-show="!roomId"></sym-combo>
    </header>

    <section class="chat-body">

      <div class="chat-users-container charcoal darken-8">
        <p class="p-2 info text-center mb-0" v-show="roomName">{{ roomName }}</p>

        <ul class="chat-users">
          <li v-for="(user, index) in users" :key="index" class="chat-user">
            <span>{{ user.userName }}</span>
          </li>
        </ul>
      </div>

      <div class="chat-messages-container" ref="mssgcont">
        <ul class="chat-messages">
          <li v-for="(msg, index) in messages" :key="index" class="chat-message list-item curved-2 shadow-light" :class="getMessageClass(msg)">
            <p class="sender-name bold mb-1" v-show="!isSenderSymChat(msg)">{{ msg.senderName }}</p>
            <p class="mb-0">{{ msg.message }}</p>
            <p class="mb-0 text-right sm-3">{{ core.toDateFormat(msg.messageDateTime, true, 'h:mm tt MMM dd ') }}</p>
          </li>
        </ul>
      </div>

    </section>

    <div class="chat-text charcoal curved-bottom-1">
      <sym-memo v-model="text" type="search" :input-height="2" class="w-100" cue="Type a message..."></sym-memo>
      <button type="button" class="send-btn success w-100 d-inline-block" @click="onSendMessage"><i class="fa fa-send mb-0"></i><br><span>Send</span></button>
    </div>

  </div>

</section>
</template>

<script>

import
  io
from "socket.io-client";

import {
  ajax,
  get
} from '../../js/http';

import {
  appConfig
} from '../../js/session';

import
  PageBase
from '../PageBase.vue';

const SymChat_SenderId = 100000;
const SymChat_SenderName = 'LAMS Chat';

export default {
  extends: PageBase,
  name: 'lms4900',

  data () {
    return {
      roomId: 0,
      roomName: '',
      rooms: [],
      users: [],
      messages: [],
      text: ''
    };
  },

  methods: {

    // api calls

    getChatRooms () {
      return get('api/accounts/' + this.sym.userInfo.accountCode + '/rooms');
    },

    getRoomMessages () {
      return get('api/rooms/' + this.roomId.toString() + '/messages');
    },

    createMessage (roomId, senderId, message) {
      const me = this;

      let senderName = senderId === SymChat_SenderId ? SymChat_SenderName : me.sym.userInfo.userName;

      let payload = {
        roomId,
        senderId,
        senderName,
        message
      };

      const
        body = JSON.stringify(payload),
        options = me.core.getAjaxOptions('POST', body);

      return ajax('api/messages', options);
    },

    // event handlers

    onSocketFault () {
      this.advice.fault('Cannot connect to the Chat Service.');
    },

    onUsersUpdated (e) {
      this.users = e.users;
    },

    onRoomIdChanged () {
      const me = this;

      me.getRoomMessages().then(
        chats => {
          me.messages = chats;
          me.onEnterRoom();

          let room = me.rooms.find( o => o.roomId === me.roomId);
          if (room) {
            me.roomName = room.roomName;
          }

          // Scroll down to show last message
          me.scrollToLastMessage();
        },
        fault => {
          me.showFault(fault);
        }
      );
    },

    onEnterRoom () {
      const
        me = this,
        userInfo = me.sym.userInfo,
        message = userInfo.userName + ' joined the room.';

      me.socket.emit('enter-room', {
        accountId: userInfo.accountId,
        userName: userInfo.userName,
        userShortName: userInfo.userShortName,
        roomId: me.roomId,
        message
      });

      // Log the message
      me.createMessage(me.roomId, SymChat_SenderId, message);

    },

    onExitRoom () {
      const
        me = this,
        userInfo = me.sym.userInfo,
        message = userInfo.userName + ' left the room.';

      me.socket.emit('exit-room', {
        accountId: userInfo.accountId,
        userName: userInfo.userName,
        userShortName: userInfo.userShortName,
        roomId: me.roomId,
        message
      });

      let roomId = me.roomId;

      // Reset model
      me.roomId = 0;
      me.roomName = '';
      me.users = [];
      me.messages = [];

      // Log the message
      me.createMessage(roomId, SymChat_SenderId, message);

    },

    onNewMessage (msg) {
      const me = this;

      me.messages.push(msg);
      me.scrollToLastMessage();
    },

    onSendMessage () {
      const
        me = this,
        userInfo = me.sym.userInfo;

      if (!me.text || !me.roomId) {
        return;
      }

      let now = new Date();
      let msg = {
        message: me.text,
        messageDateTime: now.toISOString(),
        senderId: userInfo.accountId,
        senderName: userInfo.userName
      }

      let msgInfo = {
        roomId: me.roomId,
        msg: msg
      }

      me.messages.push(msg);
      me.scrollToLastMessage();

      // Send message to chat server

      me.socket.emit('client-message', msgInfo);

      // Log the message
      me.createMessage(me.roomId, me.sym.userInfo.accountId, me.text);

      me.text = '';
      // me.setFocus('text');
    },

    // helpers

    getMessageClass (msgInfo) {
      switch (msgInfo.senderId) {
        case this.sym.userInfo.accountId:
          return 'arcticblue own-message';

        case SymChat_SenderId:
          return 'gainsboro';

        default:
          return 'beige';
      }
    },

    scrollToLastMessage () {
      const me = this;

      me.$nextTick( () => {
        let list = me.$refs.mssgcont;
        if (list) {
          list.scrollTop = list.scrollHeight;
        }
      });
    },

    isSenderSymChat (message) {
      return message.senderId === SymChat_SenderId;
    }

  },

  created () {
    this.socket = null;
  },

  mounted () {
    const me = this;

    me.getChatRooms().then(
      rooms => {
        rooms.unshift(
          { roomId: 0, roomName: '--- Select Chat Room ---' }
        );
        me.rooms = rooms;
      },
      fault => {
        me.showFault(fault);
      }
    );

    me.dom.hideGoTop();

    // me.socket = io('http://192.168.254.127:3000/');
    me.socket = io(appConfig.chatServerUrl);

    // listen to socket events

    me.socket.on('connect_error', me.onSocketFault);
    me.socket.on('users-updated', me.onUsersUpdated);
    me.socket.on('message', me.onNewMessage);

  },

  beforeDestroy () {
    const me = this;

    if (me.socket) {
      me.socket.off('connect_error', me.onSocketFault);
      me.socket.off('users-updated', me.onUsersUpdated);
      me.socket.off('message', me.onNewMessage);
      me.socket.disconnect();
      me.socket = null;
    }

    me.dom.showGoTop();

  }

}

</script>

<style scoped>

.lms4900-container {
  display: flex;
  justify-content: center;
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.lms4900 {
  display: grid;
  grid-template-rows: auto 1fr auto;
  width: 80%;
  border-radius: .375rem;
  min-height: 85vh;
}

.chat-header {
  display: flex;
  padding: .75rem 1rem;
  justify-content: space-between;
  align-items: center;
}

.chat-app-name {
  font-size: 1.5rem;
  color:cornsilk;
}

.room-select {
  width: 40%;
}

.chat-body {
  display: grid;
  grid-template-columns: 2fr 5fr;
}

.chat-user {
  display: block;
  padding: .375rem .75rem;
  margin-bottom: -1px;
  border: 1px solid rgba(240, 240, 240, .5);
  border-left: none;
  border-right: none;
}

.chat-messages-container {
  background:lightslategray;
  padding: .75rem 1rem 1rem;

  overflow-y: scroll;
  max-height: 67vh;
  border-left: 1px solid #36454f;
  border-right: 1px solid #36454f;
}

.chat-messages {
  display: grid;
  gap: .75rem;
  font-size: 1.0625rem;
}

.chat-message {
  width: 70%;
}

.own-message {
  margin-left: auto;
  margin-right: .125rem;
}

.chat-text {
  display: grid;
  grid-template-columns: auto 4.5rem;
  gap: .5rem;
  align-items: center;
  padding: 1rem 1.125rem;
}

.chat-text >>> .form-control {
  margin-bottom: 0;
}

.chat-text >>> textarea {
  line-height: 1;
  font-size: 1.125rem;
}

.sender-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.send-btn {
  line-height: 1.5;
}

header >>> .form-control {
  display: block;
  margin-bottom: 0;
}

@media (max-width: 1400px) {
  .lms4900 {
    width: 90%;
  }
}

@media (max-width: 1200px) {
  .lms4900 {
    width: 98.4%;
  }
}

@media (max-width: 800px) {
  .room-select {
    width: 50%;
  }

  .chat-users-container {
    display: none;
  }

  .chat-body {
    grid-template-columns: 1fr;
  }

}

@media (max-width: 640px) {
  .lms4900-container {
    padding-top: .125rem;
  }

  .chat-app-name {
    font-size: 1.25rem;
    margin-bottom: .25rem !important;
  }

  .chat-header {
    display: block;
    padding: .5rem;
  }

  .room-select {
    width: 100%;
  }

  .chat-body {
    line-height: 1.2;
  }

  .chat-message {
    width: 80%;
  }

  .chat-text {
    padding: .5rem;
  }

}

</style>